import React from 'react';
import range from 'lodash/fp/range';
import styled from 'styled-components';
import { PageLink } from './PageLink';
import { PaginateItem } from './PaginateItem';

const windowrange = (width: number, index: number, max: number) => {
  const offset = Math.ceil(width / 2);

  const [start, end] =
    max <= width
      ? [0, max]
      : index <= offset
        ? [0, width]
        : index + offset >= max
          ? [max - width, max]
          : [index - offset, index + offset];

  return range(start, end).map(value => value + 1);
};

export interface PaginateProps {
  range?: number;
  current: number;
  pages: number;
  href: (page: number) => string;
  resetScrollOnPageChange?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export function Paginate({ range = 10, ...props }: PaginateProps) {
  const win = windowrange(range, props.current, props.pages);
  if (props.pages === 0) {
    return null;
  }
  return (
    <StyledPagination className="pagination">
      {props.current > 1 ? (
        <PageLink {...props} page={props.current - 1}>
          &laquo;
        </PageLink>
      ) : (
        <PaginateItem>
          <span>&laquo;</span>
        </PaginateItem>
      )}
      {win.includes(1) ? null : (
        <React.Fragment>
          <PageLink {...props} page={1} />
          <PaginateItem>
            <span>...</span>
          </PaginateItem>
        </React.Fragment>
      )}
      {win.map(page => (
        <PageLink
          active={page === props.current}
          key={page}
          {...props}
          page={page}
        />
      ))}
      {win.includes(props.pages) ? null : (
        <React.Fragment>
          <PaginateItem>
            <span>...</span>
          </PaginateItem>
          <PageLink {...props} page={props.pages} />
        </React.Fragment>
      )}
      {props.current < props.pages ? (
        <PageLink {...props} page={props.current + 1}>
          &raquo;
        </PageLink>
      ) : (
        <PaginateItem>
          <span>&raquo;</span>
        </PaginateItem>
      )}
    </StyledPagination>
  );
}

const StyledPagination = styled.ol`
  list-style-type: none;
  font-family: var(--FONT_SERIF);
`;
